import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	valueText: {
		maxWidth: "200px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
}))

export default useStyles
